<template>
    <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="formDisabled">
            <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="告警级别" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="alertLevel">
                            <j-dict-select-tag type="list" v-model="model.alertLevel" dictCode="alert_level" placeholder="请选择告警级别" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-model-item label="告警声音" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="iotNoticeType">
                            <j-dict-select-tag type="radio" v-model="model.iotNoticeType" :trigger-change="true" dictCode="iot_notice_type" @change="playSounds" />
                        </a-form-model-item>
                    </a-col>

                    <!--   <a-col :span="24" v-if="model.iotNoticeType && model.iotNoticeType == 'custom'"> -->
                    <a-col :span="24">
                        <a-form-model-item :colon="false" label=" " :labelCol="labelCol" :wrapperCol="wrapperCol" prop="iotNoticeSound">
                            <a-col :span="1">
                                <a-icon v-if="(model.iotNoticeType && model.iotNoticeType != 'custom') || ((model.iotNoticeType && model.iotNoticeType == 'custom')&& model.iotNoticeSound && model.iotNoticeSound.url)" @click="playSounds" class="jessibuca-btn" theme="filled" type="audio" />
                            </a-col>
                            <a-col :span="20">
                                <a-upload :action="minioUploadAction" :headers="tokenHeader" :multiple="false" v-model:file-list="model.iotNoticeSound" @change="handleChange" :accept="fileType" :showUploadList="false" :max-count="1" :before-upload="beforeUpload">
                                    <a-button icon="upload">上传文件</a-button>
                                </a-upload>
                            </a-col>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </j-form-container>
    </a-spin>
</template>

<script>
    import { httpAction, getAction } from '@/api/manage'
    import { validateDuplicateValue } from '@/utils/util'
    import AudioPlayer from './audioPlayer'
    const audioPlayer = new AudioPlayer()
    import { validatenull, validatenotnull } from '@/utils/validate'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'

    export default {
        name: 'AlertNoticeForm',
        mixins: [JeecgListMixin],
        components: {},
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                disableMixinCreated: true,
                model: {
                    iotNoticeSound: {},
                },
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 4 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                confirmLoading: false,
                validatorRules: {
                    alertLevel: [
                        { required: true, message: '请输入告警级别!' },
                    ],
                },
                url: {
                    add: "/alert/alertNotice/add",
                    edit: "/alert/alertNotice/edit",
                    queryById: "/alert/alertNotice/queryById",
                    minioUpload: "/sys/upload/uploadMinio"
                },
                fileType: 'audio/ogg,audio/mp3,audio/wav,audio/m4a,audio/flac',
            }
        },
        computed: {
            formDisabled() {
                return this.disabled
            },
            /** 上传请求地址 */
            minioUploadAction() {
                return window._CONFIG['domianURL'] + this.url.minioUpload;
            },
        },
        created() {
            //备份model原始值
            this.modelDefault = JSON.parse(JSON.stringify(this.model));
        },
        methods: {
            add() {
                this.edit(this.modelDefault);
            },
            edit(record) {
                this.model = Object.assign({}, record);
                this.visible = true;
                this.playSounds()
            },
            submitForm() {
                const that = this;
                // 触发表单验证
                this.$refs.form.validate(valid => {
                    if (valid) {
                        that.confirmLoading = true;
                        let httpurl = '';
                        let method = '';
                        if (!this.model.id) {
                            httpurl += this.url.add;
                            method = 'post';
                        } else {
                            httpurl += this.url.edit;
                            method = 'put';
                        }
                        httpAction(httpurl, this.model, method).then((res) => {
                            if (res.success) {
                                that.$message.success(res.message);
                                that.$emit('ok');
                            } else {
                                that.$message.warning(res.message);
                            }
                        }).finally(() => {
                            that.confirmLoading = false;
                        })
                    }

                })
            },
            playSounds() {
                if (validatenull(this.model.iotNoticeType)) {
                    return;
                }
                if (this.model.iotNoticeType == 'custom') {
                    if (validatenull(this.model.iotNoticeSound)) {
                        return;
                    }
                    let audio = new Audio(); //在VUE中使用audio标签
                    audio.src = this.model.iotNoticeSound.url; //设置audio的src为上面生成的url
                    audioPlayer.playAudio(audio)
                } else {
                    audioPlayer.playOnce(this.model.iotNoticeType)
                    this.model.iotNoticeSound = {}
                }
            },
            handleChange(info) {
                this.model.iotNoticeSound = {}
                if (info.file.status === 'done') {
                    if (info.file.response.success) {
                        this.$message.success(`${info.file.name} 上传成功!`);
                    } else {
                        this.$message.error(`${info.file.response.message}`);
                    }
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.response.message}`);
                }
                if (validatenotnull(info.file)) {
                    if (info.file.response) {
                        this.model.iotNoticeSound = Object.assign(info.file, { url: info.file.response.message })
                    }
                    this.playSounds()
                }
            },
            beforeUpload(file) {
                const isAudio = file.type === 'audio/ogg' || file.type === 'audio/mp3' || file.type === 'audio/wav' ||
                    file.type === 'audio/m4a' || file.type === 'audio/flac' || file.type === 'audio/mpeg';
                if (!isAudio) {
                    this.$message.error('You can only upload Audio file!');
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('Image must smaller than 2MB!');
                }
                return isAudio && isLt2M;
            }

        }
    }
</script>
<style lang="less" scoped>

</style>